import environment from '@/modules/cart/environments/environment';
import httpClient from '@/modules/cart/services/api/client';

const { CART_URL } = environment;

export const addToCartMock = async () => {
  return await httpClient.post(`${CART_URL}/line-items`, [
    {
      sku: '276383002',
      quantity: 1
    }
  ]);
};
